export function shortenProfileName(name: string): string {
    if (!name) return ''

    const parts = name.trim().split(/\s+/).filter(Boolean)

    if (parts.length === 0) return ''

    return parts.map((part) => part.charAt(0).toUpperCase()).join('.') + '.'
}
